import restApi from "@plannel/services/utils/rest-api";

const getNote = (data) => {
  return restApi.post("/api/note", data);
};

const upsertNote = (data) => {
  return restApi.post("/api/note/upsert", data);
}

const deleteNote = (data) => {
  return restApi.post("/api/note/delete", data);
}

const dpNoteService = {
  getNote,
  upsertNote,
  deleteNote
};

export default dpNoteService;